module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "color-bg"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('coupons'), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('shopping-cart')], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-38df3f02","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shop/cart-tab.vue
// module id = 269
// module chunks = 1